<template>
  <v-card :height="gridHeight">
    <ejs-grid
      ref="grid"
      :dataSource="agendaData"
      :dataBound="dataBound"
      :enableAdaptiveUI="false"
      :beforeDataBound="beforeDataBound"
      height="100%"
      :frozenColumns="6"
      :allowSelection="false"
      :allowResizing="true"
      :allowSorting="true"
      :allowMultiSorting="true"
      :sortSettings="sortOptions"
      :enableHover="false"
      width="100%"
      gridLines="Both"
      :allowTextWrap="true"
      :textWrapSettings="wrapSettings"
      :queryCellInfo="queryCellInfoEvent"
      :commandClick="commandClick"
    >
      <e-columns>
        <e-column
          field="id"
          headerText="Agenda ID"
          textAlign="Right"
          width="100"
          :visible="false"
          isPrimaryKey="{true}"
        ></e-column>
        <e-column
          field="category.order"
          headerText="Category Order"
          textAlign="Right"
          width="100"
          :visible="false"
        ></e-column>
        <e-column
          field="category.name"
          headerText="Category"     
          width="100"
        ></e-column>
        <e-column
          field="meetingType.label"
          headerText="Meeting Type"        
          width="200"
        ></e-column>
        <e-column
          field="agendaName"
          headerText="Agenda"
          width="300"
          :visible="false"
        ></e-column>
        <e-column
          field="topics"
          headerText="Agenda & Topics"
          width="300"
          :allowSorting="false"
          :template="topicsTemplate(true)"
        ></e-column>
        <e-column
          field="priority"
          headerText="Priority"
          width="100"
          :allowSorting="false"
          :template="coloredPriorityChipTemplate('priority')"
        ></e-column>
        <e-column
          field="frequency"
          headerText="Frequency"
          width="100"
          :allowSorting="false"
          :template="coloredPriorityChipTemplate('frequency')"
        ></e-column>
        <e-column
          field="resolutionType"
          headerText="Resolution Type"
          width="100"
          :allowSorting="false"
          :visible="false"
          :template="coloredPriorityChipTemplate('resolution')"
        ></e-column>

        <e-column
          field="memo"
          headerText="Note"
          width="300"
          :allowSorting="false"
        ></e-column>
        <e-column
          headerText="Action"
          width="120"
          :commands="commands"
        ></e-column>
      </e-columns>
    </ejs-grid>
    <ConfirmDialog ref="confirm" @ok="onConfirmOK" @cancel="onConfirmCancel" />
  </v-card>
</template>

<style scoped>
::v-deep .e-grid .e-gridheader {
  background-color: lightgray;
}
::v-deep .e-grid .e-frozenheader {
  background-color: lightcoral !important;
}

::v-deep .e-grid .e-headercell {
  height: 30px;
  color: var(--v-secondary-darken1);
  background-color: var(--v-appBar-darken1);
  border-bottom: 2px solid var(--v-appBar-darken2) !important;
}

::v-deep .e-table,
.e-grid .e-frozencontent .e-virtualtable > .e-table,
.e-grid .e-frozenheader .e-virtualtable > .e-table {
  border-right-color: var(--v-appBar-darken2) !important;
}

::v-deep .e-pager .e-currentitem,
.e-pager .e-currentitem:hover {
  background: var(--v-pageHeader-base);
  color: #fff;
  opacity: 1;
}

::v-deep .e-grid .e-content.c-scroll {
  overflow-y: auto;
}
</style>
<script>
import Vue from "vue";
import AgendaPage from "@/components/agenda/agendaPage.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import topicTemplateNew from "@/components/agenda/topicTemplate.vue";
import coloredChipTemplate from "@/components/agenda/coloredChipTemplate.vue";
import {
  GridPlugin,
  Freeze,
  Resize,
  Sort,
  Page,
  Toolbar,
  Group,
  Search,
  Edit,
  CommandColumn,
} from "@syncfusion/ej2-vue-grids";
import { mapActions } from "vuex";

Vue.use(GridPlugin);

export default {
  name: "AgendaMasterGrid",
  provide: {
    grid: [Freeze, Resize, Sort, Page, Search, Edit, CommandColumn],
  },
  props: {
    agendaData: Array,
    searchText: String,
    gridHeight: Number,
  },
  watch: {
    searchText() {
      this.$refs.grid.search(this.searchText);
    },
  },

  components: {
    ConfirmDialog,
  },
  data: () => {
    return {
      selectedRow: null,
      pageSetting: { pageSize: 5 },
      toolbar: ["Search"],
      wrapSettings: { wrapMode: "Content" },
      groupOptions: { columns: ["category.name"] },
      sortOptions: {
        columns: [{ field: "category.order", direction: "Ascending" },{ field: "category.name", direction: "Ascending" }],
      },
          topicsTemplate: function (isTopicsCol) {
        return () => {
          return {
            template: {
              extends: topicTemplateNew,
              data() {
                return {
                  data: {},
                };
              },
              propsData: { isTopicsColumn: isTopicsCol },
            },
          };
        };
      },
      coloredPriorityChipTemplate: function (col) {
        return () => {
          return {
            template: {
              extends: coloredChipTemplate,
              data() {
                return {
                  data: {},
                };
              },
              propsData: { chipColumn: col, textValue: "" },
            },
          };
        };
      },

      categorySpanData: [],
      trackSpan: {},
      editSettings: {
        allowEditing: true,
        allowDeleting: false,
        mode: "Dialog",
        template: function () {
          return { template: AgendaPage };
        },
      },
      commands: [
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
        {
          type: "Delete",
          buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" },
        },
        {
          type: "Save",
          buttonOption: { cssClass: "e-flat", iconCss: "e-update e-icons" },
        },
        {
          type: "Cancel",
          buttonOption: {
            cssClass: "e-flat",
            iconCss: "e-cancel-icon e-icons",
          },
        },
      ],
    };
  },

  created() {
    //this.agendaData = this.initializeData();
    //this.trackSpan = {};
    //this.categorySpanData = this.getCategorySpanInfoArray();
    //alert(JSON.stringify(this.categorySpanData));
  },

  computed: {},
  methods: {
    ...mapActions({
      deleteAgenda: "agenda/deleteAgenda",
    }),
    async onConfirmOK() {
      if (this.selectedRow) {
        await this.deleteAgenda(this.selectedRow.id);
        this.selectedRow = null;
      }
    },
    onConfirmCancel() {
      //  todo
    },
    beforeDataBound: function (args) {
      var gridObj =
        document.getElementsByClassName("e-grid")[0].ej2_instances[0];

      if (args.count === 0) {
        gridObj.getContent().children[0].classList.add("c-scroll");
      }
    },
    commandClick: function (args) {
      if (args.commandColumn.type === "Edit") {
        this.selectedRow = args.rowData;
        this.$emit("onEditRow", args.rowData);
        args.cancel = true;
      } else if (args.commandColumn.type === "Delete") {
        this.selectedRow = args.rowData;
        args.cancel = true;
        if (
          this.$refs.confirm.open(
            this.$t("agenda.hDeleteMessage"),
            this.$t("agenda.lblDeleteMessage")
          )
        ) {
          args.cancel = false;
        } else {
        }
      }
      //alert(JSON.stringify(args.commandColumn.type));
    },
    load: function () {
      let rowHeight = this.$refs.grid.ej2Instances.getRowHeight(); //height of the each row
      let gridHeight = this.$refs.grid.height; //grid height
      let pageSize = this.$refs.grid.pageSettings.pageSize; //initial page size
      let pageResize = (gridHeight - pageSize * rowHeight) / rowHeight; //new page size is obtained here
      this.$refs.grid.pageSettings = {
        pageSize: pageSize + Math.round(pageResize),
      };
    },
    dataBound: function () {
      this.$refs.grid.autoFitColumns([
        "meetingType.label",
        "category.name",
        "agendaName",
        "priority",
        "frequency",
        "resolutionType",
      ]);
    },
    queryCellInfoEvent: function (args) {
      let data = args.data;

      if (args.column.field === "category.name") {
        args.cell.style.backgroundColor = data.category.color;
        args.cell.style.color = "white";
        //args.cell.style.fontWeight  = "500";
      } else if (args.column.field === "meetingType.label") {
        args.cell.style.backgroundColor = data.meetingType.color;
        // args.cell.style.fontWeight  = "600";
      } else if (args.column.field === "agendaName") {
        args.cell.style.backgroundColor = "var(--v-appBar-base)";
      } else if (args.column.field === "topics") {
        args.cell.style.backgroundColor = "var(--v-appBar-base)";
      } else {
        args.cell.style.backgroundColor = "var(--v-appBar-base)";
      }
    },

    getCategorySpanInfoArray() {
      const databyCategory = this.groupBy(this.agendaData, "category");
      var res = {};
      for (const key in databyCategory) {
        res[key] = databyCategory[key].length;
      }
      return res;
    },

    groupBy(array, key) {
      // Return the end result
      return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key].name] =
          result[currentValue[key].name] || []).push(currentValue);
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
      }, {}); // empty object is the initial value for result object
    },
  },
};
</script>